module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-info",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "input-group-btn"
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-upload"
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": function($event) {
        return _vm.loadPhoto($event)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.photoText),
      expression: "photoText"
    }],
    staticClass: "form-control",
    style: (_vm.style),
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.photoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.photoText = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03cf2c82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputFileNotBase64.vue
// module id = 947
// module chunks = 34